export default __webpack_public_path__ + "static/media/logo4.96f338ce.png";